import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class BlokeKullanici {

  eventCode = 'bbn';

  setEventObject(detay: string, merchantCode: string) {

    let eventObject = {
      code: this.eventCode,
      ea: detay,
      eb: merchantCode
    };

    return eventObject;
  }

}


